import axios from "axios";

export const API = `${(typeof window !== "undefined" && window.BACKEND_URL) || process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 20000 });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("hotc_admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(detail);
}

export const DEFAULT_SETTINGS = {
  business_name: "HARI OM TRADING CO.",
  tagline: "Electrical & Industrial Product Supplier",
  phone: "+91 82792 21172",
  phone_raw: "+918279221172",
  secondary_phone: "[VERIFY SECONDARY PHONE]",
  email: "[VERIFY BUSINESS EMAIL]",
  whatsapp: "918279221172",
  address_line1: "Garhshankar–Nangal Road, Near UCO Bank",
  address_line2: "Tahliwal, Himachal Pradesh 174507, India",
  hours_weekday: "Monday–Saturday: 9:00 AM–7:30 PM",
  hours_sunday: "Sunday: [VERIFY]",
  maps_url: "https://www.google.com/maps?cid=10244325204031080336",
  maps_embed: "https://maps.google.com/maps?cid=10244325204031080336&output=embed",
  google_rating: "4.9",
  google_reviews_count: "12",
  google_reviews_url: "https://www.google.com/maps?cid=10244325204031080336",
  social_instagram: "https://www.instagram.com/hariomtradingco2/",
  festive_banner_enabled: "false",
  festive_banner_text: "",
  festive_banner_cta: "",
  festive_banner_link: "/quote",
  established: "2018",
  location: "Tahliwal, Una, Himachal Pradesh",
  seo_title: "Hari Om Trading Co. | Electrical & Industrial Products in Tahliwal, Una",
  seo_description: "Hari Om Trading Co. supplies electrical, industrial automation, switchgear, lighting and pneumatic products from Tahliwal, Una, Himachal Pradesh. Enquire today.",
};

export const waLink = (settings, text) =>
  `https://wa.me/${(settings?.whatsapp || DEFAULT_SETTINGS.whatsapp).replace(/[^0-9]/g, "")}?text=${encodeURIComponent(text || "Hello Hari Om Trading Co., I have a product enquiry.")}`;

export const telLink = (settings) => `tel:${(settings?.phone_raw || DEFAULT_SETTINGS.phone_raw)}`;
